module.exports = __webpack_public_path__ + "img/控制台.42c82708.png";